const actions = {
  setJobListFilters({ commit }, payload) {
    commit('SET_JOB_LIST_FILTERS', payload);
  },
  clearJobListFilters({ commit }) {
    commit('CLEAR_JOB_LIST_FILTERS');
  },
};

export default actions;
